export default "__VITE_ASSET__DTW9gVOD__"